import { render, staticRenderFns } from "./cache.vue?vue&type=template&id=b5c63100&scoped=true&"
import script from "./cache.vue?vue&type=script&lang=js&"
export * from "./cache.vue?vue&type=script&lang=js&"
import style0 from "./cache.vue?vue&type=style&index=0&id=b5c63100&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c63100",
  null
  
)

export default component.exports